import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const EcofriendlyGiftsforemployees =()=>{
    const CTAContent = [
        {
          pageName: "Eco-Friendly Gifts for Employees",
          paragraphitalic: "Gifts that Give Back to the Earth ",
          paragraphText:
                "Show your employees how much you value their contribution and your shared commitment to sustainability. Our range of eco-friendly gifts for employees includes everything from plant-based products to reusable gadgets – perfect for fostering a green work culture. ",
          ContactFormName: "Eco-Friendly Gifts for Employees",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Eco-Friendly Desk Accessories",
          parapgraphItalic: "Upgrade Your Workspace with Sustainable Elegance!",
          sectionparagraphText: (
            <>
              <p>
              Practical, stylish desk accessories that work for you and the planet. 
                </p>
                <p>
                Transform your workspace into an eco-friendly haven with our curated range of desk accessories. Crafted from sustainable materials like bamboo, cork, and recycled plastics, these products combine functionality and aesthetics. Whether for personal use or corporate gifting, these accessories are a perfect way to show your commitment to the environment. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for Employees/Eco-Friendly Desk Accessories.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Sustainable Apparel & Accessories",
          parapgraphItalic: "Wear Your Values, Look Great!",
          sectionparagraphText: (
            <>
              <p>
                Stylish apparel and accessories that make a statement for sustainability. 
                </p>
                <p>
                Redefine fashion with sustainable apparel and accessories that blend comfort, style, and responsibility. Our collection includes T-shirts, caps, tote bags, and scarves made from organic cotton, recycled fabrics, and biodegradable materials. Perfect for corporate gifting or personal use, these items help you express your eco-conscious values effortlessly. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for Employees/Sustainable Apparel & Accessories.jpg",
          categoryHeadingLeftSide: "Features That Set Trends",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Employees/Eco-Friendly Fabrics.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Eco-Friendly Fabrics</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Employees/Timeless Accessories.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Timeless Accessories</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Employees/Custom Printing & Embroidery.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Custom Printing & Embroidery</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Employees/Features That Inspire Productivity.jpg",
          NogapHeading: "Features That Inspire Productivity",
          Heading: [
            {
              ListHeading: "Bamboo Organizers",
              ListParagraph:
                "Stylish and sustainable storage solutions for your desk",
            },
            {
              ListHeading: "Recycled Notebooks and Planners",
              ListParagraph:
                "Keep track of tasks with eco-friendly options.",
            },
            {
              ListHeading: "Eco-Friendly Mouse Pads",
              ListParagraph:
                "Made from biodegradable materials for a smooth and green workflow.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Employees/Biodegradable Gift Sets.jpg",
          NogapHeading: "Biodegradable Gift Sets",
          paragraphItalic: "Gifts That Give Back to the Earth!",
          paragraphDetail: (
            <>
              <p>
              Biodegradable gift sets designed to make every occasion meaningful. 
                </p>
                <p>
                Celebrate special moments with gift sets that prioritize the planet. Our biodegradable gift sets include plantable items, compostable packaging, and thoughtfully curated eco-friendly products. These sets are ideal for corporate gifting, festivals, or personal milestones, ensuring your gestures leave no trace on the environment. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Make an Impact",
          Categories: [
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Employees/Plantable Gifts.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Plantable Gifts</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Employees/Natural Products.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Natural Products</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Employees/Compostable Packaging.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Compostable Packaging</b>
                  </p>
                </>
              ),
            },
          ],
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Employees/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>Appreciate dedication and achievements.</p>
              <p>
                Show appreciation for the hard work and dedication that goes into
                every achievement.
              </p>
              <p>
                Milestones such as work anniversaries, project completions, and
                promotions deserve to be celebrated. At eYantra, we provide a range
                of premium milestone gifts that are as unique as the achievements.
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Employees/logo-printing.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Employees/engraving.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Employees/Luxury Gift Hampers.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>eYantra Eco-Friendly Gifts in Hyderabad</title>
        <meta name="description" content="eYantra offers eco-friendly gifts, branded merchandise, joining kits, and welcome kits with sustainable corporate gifting solutions across Hyderabad."/>
        <meta name="keywords" content="eyantra,  eco friendly gifts, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits,corporate gifts in hyderabad, branded corporate,"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container >
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Vest your employees with gifts that reflect shared values and contribute to a healthier planet. 
      </p>
    </>
  );
};

export default EcofriendlyGiftsforemployees;